import styled from '@emotion/styled';
import { ReactComponent as ReceiptIc } from 'assets/icons/receipt.svg';

import theme from 'styles/theme';

export const Container = styled.div`
  background-color: white;
  border-radius: 10px;
  width: auto;
  padding: 32px 24px;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2px;
`;

export const Left = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.span`
  font-size: 18px;
  color: ${theme.colors.secondaryText};
`;

export const CloseIcon = styled.span`
  font-size: 22px;
  color: #074f8c;
  cursor: pointer;
`;

export const Content = styled.span`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Item = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 25px;
`;

export const SectionTitle = styled.span`
  font-size: 18px;
  color: #074f8c;
`;

export const Icon = styled.span`
  font-size: 18px;
  cursor: pointer;
  color: black;
`;

export const ItemIcon = styled.span`
  font-size: 22px;
  color: ${theme.colors.secondaryText};
  margin-right: 15px;
`;

export const ReceiptIcon = styled(ReceiptIc)`
  height: 22px;
  width: 22px;
  margin-right: 15px;

  path,
  .a {
    fill: none;
  }

  path,
  .b {
    fill: ${theme.colors.secondaryText};
  }
`;
